export default defineNuxtPlugin((NuxtApp) => {
  NuxtApp.$store.$router = NuxtApp.$router;
  NuxtApp.$store.localePath = NuxtApp.$localePath;
  NuxtApp.$store.$i18n = NuxtApp.$i18n;
  NuxtApp.$store.$env = NuxtApp.$env;
});
